// extracted by mini-css-extract-plugin
module.exports = {"versionCard":"VersionCard_versionCard__2FSpl"};